module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [(_vm.ownerEditInvite) ? _c('div', [_vm._m(1)]) : _c('div', [_c('p', [_vm._v("Selecione um usuário abaixo. Um email será enviado para formalizar o convite.")]), _vm._v(" "), _c('div', {
    staticClass: "users-table"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUsers]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUsers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-table', {
    staticClass: "users-table",
    attrs: {
      "items": _vm.users,
      "fields": _vm.userFields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(item) {
        return _c('div', {
          staticClass: "text-center"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.invite.users),
            expression: "invite.users"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": item.item,
            "checked": Array.isArray(_vm.invite.users) ? _vm._i(_vm.invite.users, item.item) > -1 : (_vm.invite.users)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.invite.users,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = item.item,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.invite, "users", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.invite, "users", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.invite, "users", $$c)
              }
            }
          }
        })])
      }
    }, {
      key: "tags",
      fn: function(item) {
        return _c('ul', {
          staticClass: "list-inline"
        }, _vm._l((item.value), function(tag) {
          return _c('li', [_c('span', {
            staticClass: "label label-primary text-capitalize"
          }, [_vm._v(_vm._s(tag))])])
        }), 0)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "size": "sm",
      "total-rows": _vm.usersCount,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getUsers
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canComment"
    }
  }, [_vm._v("Pode comentar?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite.canComment),
      expression: "invite.canComment"
    }],
    attrs: {
      "type": "checkbox",
      "id": "canComment"
    },
    domProps: {
      "checked": Array.isArray(_vm.invite.canComment) ? _vm._i(_vm.invite.canComment, null) > -1 : (_vm.invite.canComment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invite.canComment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.invite, "canComment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.invite, "canComment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.invite, "canComment", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "expires"
    }
  }, [_vm._v("Expira?")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite.expires),
      expression: "invite.expires"
    }],
    attrs: {
      "type": "checkbox",
      "id": "expires"
    },
    domProps: {
      "checked": Array.isArray(_vm.invite.expires) ? _vm._i(_vm.invite.expires, null) > -1 : (_vm.invite.expires)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invite.expires,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.invite, "expires", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.invite, "expires", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.invite, "expires", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "disabled": !_vm.invite.expires
    },
    model: {
      value: (_vm.invite.expiration),
      callback: function($$v) {
        _vm.$set(_vm.invite, "expiration", $$v)
      },
      expression: "invite.expiration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "advanced"
    }
  }, [_vm._v("Informações Compartilhadas")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Se não especificado, todos campos serão visíveis",
      "label": "name",
      "track-by": "objectId"
    },
    model: {
      value: (_vm.invite.sharedFields),
      callback: function($$v) {
        _vm.$set(_vm.invite, "sharedFields", $$v)
      },
      expression: "invite.sharedFields"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inviteEmailText"
    }
  }, [_vm._v("Texto do Email de Convites")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "inviteEmailText",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.emailText),
      callback: function($$v) {
        _vm.emailText = $$v
      },
      expression: "emailText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go('-1')
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Convidar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Convidar")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          O requisitante será notificado. "), _c('b', [_vm._v("Ele poderá modificar as informações do formulário.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d935c0e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestInviteSelect.vue
// module id = 1421
// module chunks = 1